export function capitalizeSectionTitle(value) {
  if (typeof value !== "string" || value.length === 0) return value;
  return value.replace(/\p{L}/u, (letter) => letter.toUpperCase());
}
